import { createReducer, on } from '@ngrx/store';
import * as HodActions from './hod.actions';

export const hodFeatureKey = 'hod';

export interface HodState {
  hods: Array<{ id: number; name: string }>;
  loading: boolean;
  error: string | null;
}

export const initialState: HodState = {
  hods: [],
  loading: false,
  error: null,
};

export const hodReducer = createReducer(
  initialState,
  on(HodActions.loadHods, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HodActions.loadHodsSuccess, (state, { hods }) => ({
    ...state,
    hods,
    loading: false,
    error: null,
  })),
  on(HodActions.loadHodsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
